"use strict";

exports = module.exports = {
  VERSION: '1.3.9',
  // List of user roles
  userRoles: ["user", "opadmin", "hccadmin", "admin"],
  mountainRanges: [
    "South Coast Mountains",
    "North Coast Mountains",
    "Skeena Mountains",
    "Purcell Mountains",
    "Selkirk Mountains",
    "Monashee Mountains",
    "Rocky Mountains",
    "Cariboo Mountains"
  ],
  severities: ["Near Miss", "Incident"],
  privacy: ["Private", "Shared"],
  reportStatus: ["In Progress", "Waiting for Info", "Complete"],
  incidentType: [
    "Skiing - Avalanche",
    "Skiing - Crevasse",
    "Skiing - Snow Immersion",
    "Skiing - General",
    "Hiking/Mountaineering - General",
    "Mountain Biking - General",
    "Helicopter",
    "Snowcat",
    "Snowmobile",
    "Motor Vehicle",
    "Lodge / Hotel / Base Facility",
    "Medical Condition & Illness",
    "Other"
  ],
  runClassifications: [
    "Easiest",
    "More Difficult",
    "Most Difficult",
    "Extreme"
  ],
  aspects: ["N", "S", "E", "W", "NW", "NE", "SW", "SE"],
  weatherConditions: ["Clear", "Rain", "Broken", "Fog", "Overcast", "Snow"],
  skyConditions: [
    "Clear",
    "Few",
    "Scattered",
    "Broken",
    "Overcast",
    "Obscured"
  ],
  windSpeeds: [
    "Calm [0-5kmh]",
    "Light [5-20kmh]",
    "Moderate [20-40kmh]",
    "Strong [40-60kmh]",
    "Gale [60-90kmh]",
    "Extreme [>90kmh]"
  ],
  snowConditions: [
    "Powder",
    "Chopped powder",
    "Crust",
    "Variable",
    "Corn",
    "Spring snow",
    "Deep wet"
  ],

  patientTypes: ["Guide", "Guest", "Pilot", "Staff", "Other"],

  injurySeverity: ["Uninjured", "Minor Injuries", "Major Injuries", "Deceased"],

  treatmentStatus: [
    "Initial Assessment",
    "Local Treatment",
    "Sent to Medical Facility",
    "Complete"
  ],

  treatmentOutcome: [
    "Return to Activity",
    "Stayed, but did not return to activity",
    "Went Home Early",
    "Transfer to Hospital",
    "Other"
  ],

  genderTypes: ["Male", "Female", "Other"],

  injuryLocation: [
    "Upper Leg",
    "Chest",
    "Head",
    "Abdomen",
    "Wrist",
    "Shoulder",
    "Arm"
  ],

  leftFieldBy: [
    "Skiing",
    "Ambulance",
    "Car/Bus",
    "Snowcat",
    "Snowmobile",
    "Helicopter"
  ],

  extractionMethod: [
    "Load & Go",
    "Bivi",
    "Impr. p/u",
    "Rope",
    "Toboggan",
    "Class D",
    "Not Applicable"
  ],

  destination: [
    "Lodge/Hotel",
    "External Medical Facility",
    "Onsite Doctor/Clinic",
    "Return Skiing"
  ],

  yesno: [
    {
      value: true,
      name: "Yes"
    },
    {
      value: false,
      name: "No"
    }
  ],

  yesnoUnknown: ["Yes", "No", "Unknown"],

  ability: ["Beginner", "Intermediate", "Advanced", "Expert"],

  fitness: ["Very Poor", "Poor", "Good", "Very Good"],

  natureInjury: [
    "Asphyxia",
    "Bruise/Contusion",
    "Cardiac",
    "Concussion",
    "Deceased",
    "Dehydration",
    "Dislocation",
    "Epilepsy",
    "Fracture",
    "Frostbite",
    "Heart attack",
    "Hypothermia",
    "Illness",
    "Internal",
    "Laceration/Puncture",
    "Multiple",
    "Other",
    "Sprain",
    "Strain",
    "Stroke",
    "Sunstroke",
    "Unknown"
  ],

  avalancheType: [
    "Loose Dry Avalanche",
    "Loose Wet Avalanche",
    "Storm Slab",
    "Wind Slab",
    "Peristent Slab",
    "Deep Persistent Slab",
    "Wet Slab",
    "Generic Slab",
    "Cornice Avalanche",
    "Glide Avalanche"
  ],

  avalancheSize: ["1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5"],

  humidity: ["Dry", "Wet"],

  triggerType: [
    "Na",
    "Nc",
    "Ne",
    "Ni",
    "Nr",
    "Xa",
    "Xc",
    "Xb",
    "Xe",
    "Xg",
    "Xh",
    "Xl",
    "Xp",
    "Xt",
    "Xr",
    "Xy",
    "Ha",
    "Hc",
    "Hr",
    "Hy",
    "Va",
    "Vr",
    "Vy",
    "Sa",
    "Sc",
    "Sr",
    "Sy",
    "Ma",
    "Mc",
    "Mr",
    "My",
    "O"
  ],

  burialType: [
    "Not buried",
    "Partially Buried - Not Critical",
    "Partially Buried - Critical",
    "Complete Burial"
  ],

  airbag: [
    "None",
    "Not Deployed",
    "Not Inflated",
    "Inflated",
    "Damaged/Deflated"
  ],

  locatedBy: [
    "Audiovisual",
    "Probing",
    "Beacon",
    "Dog",
    "Recco",
    "Thawing",
    "Self Rescue"
  ],

  immersionType: [
    "Tree well",
    "Rock/Boulder moat",
    "Creek bed",
    "Open terrain",
    "Other"
  ],

  obstacleType: [
    "Tree",
    "Stump",
    "Log",
    "Debris/pressed or frozen snow",
    "Rock",
    "Boulder",
    "Other Skier",
    "Snowcat",
    "Helicopter",
    "Other"
  ],

  cause: [
    "Poor visibility",
    "Equipment failure",
    "Loss of control",
    "Fall",
    "Inattentiveness",
    "Jump",
    "Depression/mound",
    "Snow conditions",
    "Sluffing",
    "Other"
  ],

  fallHazard: ["Cliff", "Crevasse", "Glacier Moulin", "Steep terrain", "Other"],

  collisionWithTerrain: ["Head-first", "Feet-first", "Sliding", "Sideways"],

  terrain: ["Snow", "Water", "Ice", "Mixed", "Rock"],

  accidentHappened: ["During the flight", "On the ground"],

  typeFlightIncident: [
    "Collision with terrain",
    "Hard landing",
    "Smoke/Fire in cabin",
    "Roll-over",
    "Contact with objects",
    "Other"
  ],

  typeGroundIncident: [
    "Impact of natural hazard",
    "Contact of person with pitot tube",
    "Contact of person with moving part of helicopter",
    "Loose object"
  ],

  typeNaturalHazard: ["Avalanche", "Icing", "Wind"],

  helicopterCause: [
    "Misassessment of weather/wind",
    "Misjudgement of landing area",
    "Overload",
    "System failure (e.g. engine failure)",
    "Inadequate pilot judgement",
    "Violation of minimum safe altitude",
    "Other"
  ],

  accidentHappenedVehicle: ["While driving", "Not driving"],

  typeVehicle: ["Truck", "Tractor", "Car", "Other"],

  typeIncidentDriving: [
    "Avalanche impact",
    "Collision with animals",
    "Collision with other vehicle",
    "Collision with other obstacles",
    "Fall from height"
  ],

  typeIncidentNotDriving: ["Avalanche impact"],

  causeVehicle: [
    "Communication breakdown",
    "Snowpack conditions",
    "Treewell",
    "Stuck/entrenched machine",
    "Distracted driving",
    "Speeding",
    "Reckless driving",
    "Drug abuse",
    "Other"
  ],

  patientPosition: ["Upright", "Horizontal", "Inverted"],

  skiIncidentType: ["Fall from height", "Collision", "Unforced fall", "Other"],

  collisionType: ["Natural object", "Man-made object", "Person"],

  crevasseType: ["Crevasse", "Moulin", "Bergschrund", "Other"],

  crevasseLocatedBy: ["Witnessed", "Audiovisual", "Beacon", "Other"],

  extricatedCondition: ["Conscious", "Unconscious", "Not breathing"],

  correctiveLenses: ["No", "Yes - worn", "Yes - not worn"],

  typeVehicleIncident: [
    "Collision With Animal",
    "Collision With Person",
    "Collision With Static Object",
    "Collision With Other Vehicle",
    "Vehicle Break Down",
    "Other"
  ],

  roadType: ["Public", "Captive"],

  operationType: ["cat", "heli", "helicat", "admin"],

  hours: [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23"
  ],

  mins: ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"]
};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 19
// module chunks = 0